import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useI18n } from '@udemy-v2/i18n';
import { useMatchMedia } from '@udemy-v2/design-system-utils';
import { publishEvent, TrackImpression } from '@udemy-v2/event-tracking';
import { Icon } from '@udemy-v2/icons';
import { BlockList } from '@udemy-v2/react-core-components';
import classNames from 'classnames';
import { CourseIncentiveImpressionEvent, CourseIncentivesImpressionEvent, IncentivesPlacement, LearningProduct } from '@/features/course-landing-page/events/events';
import { useClpCourse } from '@/features/course-landing-page/context/clp-course-provider.react-component';
import { CourseIncentive, useCourseIncentives } from './hooks/use-course-incentives.react-component';
import styles from './course-includes.module.scss';
export enum CourseIncludesPlacement {
  SIDEBAR = 'sidebar',
  BODY = 'body',
}
interface CourseIncludesProps {
  className?: string;
  placement?: CourseIncludesPlacement;
}
export const CourseIncludes = t0 => {
  const $ = _c(53);
  const {
    className,
    placement: t1
  } = t0;
  const placement = t1 === undefined ? CourseIncludesPlacement.SIDEBAR : t1;
  const {
    gettext
  } = useI18n();
  const incentiveItems = useCourseIncentives();
  const course = useClpCourse();
  const isMobile = useMatchMedia("sm-max");
  const isPlacementBody = placement === CourseIncludesPlacement.BODY;
  if (!incentiveItems || incentiveItems.length === 0) {
    return null;
  }
  let t2;
  if ($[0] !== course || $[1] !== placement) {
    t2 = () => {
      if (!course?.id) {
        return;
      }
      publishEvent(new CourseIncentivesImpressionEvent({
        courseTrackingId: course.frontendTrackingId ?? "",
        uiRegion: placement === CourseIncludesPlacement.BODY ? IncentivesPlacement.BODY : IncentivesPlacement.SIDEBAR,
        learningProduct: {
          type: LearningProduct.COURSE,
          id: parseInt(course.id, 10),
          trackingId: course.frontendTrackingId ?? ""
        }
      }));
    };
    $[0] = course;
    $[1] = placement;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleImpression = t2;
  let t3;
  if ($[3] !== course) {
    t3 = (incentive, position) => {
      if (!course?.id) {
        return;
      }
      publishEvent(new CourseIncentiveImpressionEvent({
        courseId: parseInt(course.id, 10),
        courseTrackingId: course.frontendTrackingId ?? "",
        incentiveType: incentive.type,
        position,
        incentiveValue: String(incentive.value) || ""
      }));
    };
    $[3] = course;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleIncentiveImpression = t3;
  const hasDoubleColumn = placement === CourseIncludesPlacement.BODY && !isMobile;
  const halfLength = Math.ceil(incentiveItems.length / 2);
  let T0;
  let t10;
  let t11;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[5] !== className || $[6] !== gettext || $[7] !== halfLength || $[8] !== handleImpression || $[9] !== handleIncentiveImpression || $[10] !== hasDoubleColumn || $[11] !== incentiveItems || $[12] !== isPlacementBody) {
    const firstList = hasDoubleColumn ? incentiveItems.slice(0, halfLength) : [];
    const secondList = hasDoubleColumn ? incentiveItems.slice(halfLength) : [];
    let t12;
    if ($[22] !== handleIncentiveImpression || $[23] !== isPlacementBody) {
      t12 = (incentives, t13) => {
        const positionOffset = t13 === undefined ? 0 : t13;
        return <BlockList className={styles["incentives-list"]} size="small" padding="tight">{incentives.map((incentive_0, index) => <BlockList.Item key={`incentive-${index + positionOffset}`} icon={<Icon glyph={incentive_0.iconGlyph} size={isPlacementBody ? "small" : "xsmall"} color="neutral" label={false} aria-hidden="true" />}><TrackImpression trackFunc={() => handleIncentiveImpression(incentive_0, index + positionOffset)} data-testid={`incentive-impression-${index + positionOffset}`}><span className={isPlacementBody ? "ud-text-md" : "ud-text-sm"}>{incentive_0.text}</span></TrackImpression></BlockList.Item>)}</BlockList>;
      };
      $[22] = handleIncentiveImpression;
      $[23] = isPlacementBody;
      $[24] = t12;
    } else {
      t12 = $[24];
    }
    const renderIncentivesList = t12;
    const t13 = !isPlacementBody && styles["course-includes-wrapper-sidebar"];
    if ($[25] !== className || $[26] !== t13) {
      t11 = classNames(t13, className);
      $[25] = className;
      $[26] = t13;
      $[27] = t11;
    } else {
      t11 = $[27];
    }
    T0 = TrackImpression;
    t9 = handleImpression;
    t10 = "course-includes-impression";
    const t14 = isPlacementBody ? styles["course-includes-body"] : styles["course-includes-sidebar"];
    if ($[28] !== t14) {
      t6 = classNames(t14);
      $[28] = t14;
      $[29] = t6;
    } else {
      t6 = $[29];
    }
    t7 = "course-includes";
    const t15 = isPlacementBody ? "ud-heading-xl" : "ud-heading-md";
    let t16;
    if ($[30] !== t15) {
      t16 = classNames(styles["course-heading"], t15);
      $[30] = t15;
      $[31] = t16;
    } else {
      t16 = $[31];
    }
    let t17;
    if ($[32] !== gettext) {
      t17 = gettext("This course includes:");
      $[32] = gettext;
      $[33] = t17;
    } else {
      t17 = $[33];
    }
    if ($[34] !== t16 || $[35] !== t17) {
      t8 = <h2 className={t16}>{t17}</h2>;
      $[34] = t16;
      $[35] = t17;
      $[36] = t8;
    } else {
      t8 = $[36];
    }
    t4 = styles["incentives-container"];
    t5 = hasDoubleColumn ? <div className={styles["double-list-container"]} data-testid="double-list-container">{renderIncentivesList(firstList, 0)}{renderIncentivesList(secondList, halfLength)}</div> : renderIncentivesList(incentiveItems);
    $[5] = className;
    $[6] = gettext;
    $[7] = halfLength;
    $[8] = handleImpression;
    $[9] = handleIncentiveImpression;
    $[10] = hasDoubleColumn;
    $[11] = incentiveItems;
    $[12] = isPlacementBody;
    $[13] = T0;
    $[14] = t10;
    $[15] = t11;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    T0 = $[13];
    t10 = $[14];
    t11 = $[15];
    t4 = $[16];
    t5 = $[17];
    t6 = $[18];
    t7 = $[19];
    t8 = $[20];
    t9 = $[21];
  }
  let t12;
  if ($[37] !== t4 || $[38] !== t5) {
    t12 = <div className={t4}>{t5}</div>;
    $[37] = t4;
    $[38] = t5;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  let t13;
  if ($[40] !== t12 || $[41] !== t6 || $[42] !== t7 || $[43] !== t8) {
    t13 = <div className={t6} data-testid={t7}>{t8}{t12}</div>;
    $[40] = t12;
    $[41] = t6;
    $[42] = t7;
    $[43] = t8;
    $[44] = t13;
  } else {
    t13 = $[44];
  }
  let t14;
  if ($[45] !== T0 || $[46] !== t10 || $[47] !== t13 || $[48] !== t9) {
    t14 = <T0 trackFunc={t9} data-testid={t10}>{t13}</T0>;
    $[45] = T0;
    $[46] = t10;
    $[47] = t13;
    $[48] = t9;
    $[49] = t14;
  } else {
    t14 = $[49];
  }
  let t15;
  if ($[50] !== t11 || $[51] !== t14) {
    t15 = <div className={t11}>{t14}</div>;
    $[50] = t11;
    $[51] = t14;
    $[52] = t15;
  } else {
    t15 = $[52];
  }
  return t15;
};